export default __webpack_public_path__ + "static/media/chevron-compact-down.97e29767.svg";